import NavLinkAdapter from '@fuse/core/NavLinkAdapter/NavLinkAdapter';
import FuseUtils from '@fuse/utils';
import Icon from '@material-ui/core/Icon';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { makeStyles } from '@material-ui/core/styles';
import * as Actions from 'app/store/actions';
import { getTenant } from 'app/utils/enviromentUtil';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, withRouter } from 'react-router-dom';
import FuseNavBadge from '../FuseNavBadge';

const useStyles = makeStyles((theme) => ({
  item: (props) => ({
    height: 40,
    width: 'calc(100% - 16px)',
    borderRadius: '0 20px 20px 0',
    paddingRight: 12,
    paddingLeft: props.itemPadding > 80 ? 80 : props.itemPadding,
    '&.active': {
      backgroundColor: theme.palette.primary.main,
      color: `${theme.palette.primary.contrastText}!important`,
      pointerEvents: 'none',
      transition: 'border-radius .15s cubic-bezier(0.4,0.0,0.2,1)',
      '& .list-item-text-primary': {
        color: 'inherit',
      },
      '& .list-item-icon': {
        color: 'inherit',
      },
    },
    '& .list-item-icon': {
      marginRight: 16,
    },
    '& .list-item-text': {},
    color: theme.palette.text.primary,
    cursor: 'pointer',
    textDecoration: 'none!important',
  }),
}));

function FuseNavVerticalItem(props) {
  const dispatch = useDispatch();
  const userRole = useSelector(({ auth }) => auth.user.role);
  const { item, nestedLevel } = props;
  const classes = useStyles({
    itemPadding: nestedLevel > 0 ? 40 + nestedLevel * 16 : 24,
  });
  const { t } = useTranslation('navigation');
  const location = useLocation();

  if (!FuseUtils.hasPermission(item.auth, userRole)) {
    return null;
  }

  const CustomIcon = item.icon;

  const isItemModal = [
    'dre',
    'receita',
    'despesa',
    'fluxo-de-caixa',
    'balancete',
    'fechamento_periodo',
    'venda-detalhada',
    'cliente',
    'centro-de-custo',
    'vendedores',
    'contas',
  ].includes(item.id);

  // Obtém a URL completa
  const fullUrl = `${window.location.origin}${location.pathname}${location.search}`;
  // Verifica se a URL contém a palavra 'vendedores'
  const isVendedores = fullUrl.includes('vendedores');
  // Verifica se a URL contém a palavra 'contas'
  const isContas = fullUrl.includes('contas');

  const activeClassName = isItemModal
    ? // Se é um modal de item, verifica se a página é de 'vendedores' ou 'contas' e se o ID do item corresponde
      (isVendedores && item.id === 'vendedores') || (isContas && item.id === 'contas')
      ? 'active'
      : null
    : 'active';

  const tenant = getTenant();
  const showItem =
    item.id !== 'acompanhar_regua_cobranca' ||
    !process.env.REACT_APP_TENANT_FATUREMAIS ||
    tenant === process.env.REACT_APP_TENANT_FATUREMAIS;

  return (
    showItem && (
      <ListItem
        button
        component={NavLinkAdapter}
        to={item.url}
        activeClassName={activeClassName}
        className={clsx(classes.item, 'list-item')}
        onClick={(ev) => dispatch(Actions.navbarCloseMobile())}
        exact={item.exact}
      >
        {item.icon && typeof item.icon === 'string' ? (
          <Icon className="list-item-icon text-16 flex-shrink-0" color="action">
            {item.icon}
          </Icon>
        ) : (
          <CustomIcon size={14} color="#fff" />
        )}

        {item.CustomIcon && <item.CustomIcon className="list-item-icon text-16 flex-shrink-0" />}

        <ListItemText
          className="list-item-text"
          primary={item.translate ? t(item.translate) : item.title}
          classes={{ primary: 'text-14 list-item-text-primary' }}
        />

        {item.badge && <FuseNavBadge badge={item.badge} />}
      </ListItem>
    )
  );
}

FuseNavVerticalItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string,
    icon: PropTypes.string,
    url: PropTypes.string,
  }),
};

FuseNavVerticalItem.defaultProps = {};

const NavVerticalItem = withRouter(React.memo(FuseNavVerticalItem));

export default NavVerticalItem;
